import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ImpacterPosition } from '../../models/impacter/impacter-position';

@Component({
  selector: 'app-impacter-card',
  templateUrl: './impacter-card.component.html',
  styleUrls: ['./impacter-card.component.scss']
})
export class ImpacterCardComponent implements OnChanges {
  @Input() impacterId!: string;
  @Input() name!: string;
  @Input() byFilter!: boolean;
  @Input() positions!: Array<ImpacterPosition>;
  shownPositions!: Array<ImpacterPosition>;
  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['positions']) {
      const activePositions = this.positions.filter((position) => !position.isOld);
      if (activePositions.length) {
        this.shownPositions = activePositions;
      } else {
        const inactivePositions = this.positions.filter((position) => position.isOld);
        if (inactivePositions.length) this.shownPositions = [inactivePositions[0]];
      }
    }
  }

}
